<template>
  <div>
    <div v-if="contextList.filter(x => !x.hide).length < 3 || showIcons">
      <span v-for="(context, index) in contextList" :key="index">
        <v-tooltip v-if="!context.hide" top>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-0"
              text
              :width="small ? '18' : '22'"
              depressed
              icon
              v-on="on"
            >
              <v-icon
                :disabled="context.disabled"
                :color="context.color"
                :dark="!context.disabled"
                :small="small"
                :size="size"
                dense
                @click="$emit(`click${index}`)"
                v-text="generateIcon(context.icon)"
              ></v-icon>
            </v-btn>
          </template>
          <span
            v-text="context.disabled ? context.disable_message : context.name"
          ></span>
        </v-tooltip>
      </span>
    </div>
    <v-menu v-else offset-y left transition="slide-y-transition">
      <template v-slot:activator="{ on }">
        <v-btn small text icon v-on="on">
          <v-icon v-text="$getIcon('mdiDotsHorizontal')"></v-icon>
        </v-btn>
      </template>
      <v-list
        v-for="(context, index) in contextList"
        :key="index"
        dense
        class="pa-0"
      >
        <div v-if="!context.hide">
          <v-list-item v-if="context.disabled">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-list-item-title v-on="on">
                  <v-icon
                    disabled
                    small
                    :color="context.color"
                    v-text="generateIcon(context.icon)"
                  ></v-icon>
                  <span class="ml-1 grey--text" v-text="context.name"></span>
                </v-list-item-title>
              </template>
              <span>{{ context.disable_message }}</span>
            </v-tooltip>
          </v-list-item>
          <v-list-item v-else @click="$emit(`click${index}`)">
            <v-list-item-title>
              <v-icon
                color="grey"
                small
                dense
                v-text="generateIcon(context.icon)"
              ></v-icon>
              <span class="ml-1" v-text="context.name"></span>
            </v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "VueContextMenu",
  props: {
    contextList: {
      type: Array,
      default() {
        return [];
      }
    },
    showIcons: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String],
      default: 20
    }
  },
  methods: {
    generateIcon(icon) {
      const mapper = {
        mdiPencilOutline: this.$getIcon("mdiPencilOutline"),
        mdiEyeOutline: this.$getIcon("mdiEyeOutline"),
        mdiEye: this.$getIcon("mdiEye"),
        mdiUpdate: this.$getIcon("mdiUpdate"),
        mdiShieldCheck: this.$getIcon("mdiShieldCheck"),
        mdiDelete: this.$getIcon("mdiDeleteOutline"),
        mdiCheck: this.$getIcon("mdiCheck"),
        mdiViewGrid: this.$getIcon("mdiViewGridOutline"),
        mdiCancel: this.$getIcon("mdiCancel"),
        mdiClipboardCheckOutline: this.$getIcon("mdiClipboardCheckOutline"),
        mdiForumOutline: this.$getIcon("mdiForumOutline"),
        mdiVolumeHigh: this.$getIcon("mdiVolumeHigh"),
        mdiExport: this.$getIcon("mdiExport"),
        mdiDownload: this.$getIcon("mdiDownload"),
        mdiRefresh: this.$getIcon("mdiRefresh")
      };
      return mapper[icon] || this.$getIcon("mdiInformationOutline");
    }
  }
};
</script>

<style scoped></style>
